function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3",
  "data-name": "Layer 3",
  transform: "translate(-2 -1.83)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11492",
  "data-name": "Path 11492",
  d: "M23.987,27.562A11.326,11.326,0,1,1,35.432,16.236,11.326,11.326,0,0,1,23.987,27.562Zm0-18.678a7.352,7.352,0,1,0,7.471,7.352A7.432,7.432,0,0,0,23.987,8.884Z",
  transform: "translate(10.641 3.041)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11493",
  "data-name": "Path 11493",
  d: "M23.987,27.562A11.326,11.326,0,1,1,35.432,16.236,11.326,11.326,0,0,1,23.987,27.562Zm0-18.678a7.352,7.352,0,1,0,7.471,7.352A7.432,7.432,0,0,0,23.987,8.884Z",
  transform: "translate(10.641 3.041)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11494",
  "data-name": "Path 11494",
  d: "M35.641,17.951A40.933,40.933,0,0,0,9.809,21.925,3.517,3.517,0,0,0,8,25.1v7.074a1.987,1.987,0,1,0,3.974,0V25.363A37.6,37.6,0,0,1,35.82,22.025Z",
  transform: "translate(5.922 15.314)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11495",
  "data-name": "Path 11495",
  d: "M49.78,24.448H36.467V21.507a1.987,1.987,0,0,0-3.974,0v2.941H17.987A1.987,1.987,0,0,0,16,26.435V46.306a1.987,1.987,0,0,0,1.987,1.987H49.78a1.987,1.987,0,0,0,1.987-1.987V26.435A1.987,1.987,0,0,0,49.78,24.448ZM47.793,44.319H19.974v-15.9H32.493v.815a1.987,1.987,0,1,0,3.974,0v-.815H47.793Z",
  transform: "translate(13.819 17.461)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11496",
  "data-name": "Path 11496",
  d: "M21.81,27.42H33.653V30.2H21.81Z",
  transform: "translate(19.554 25.259)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11497",
  "data-name": "Path 11497",
  d: "M19.566,12.24a35.767,35.767,0,0,0-15.8,3.974A3.318,3.318,0,0,0,2,19.135v6.16a1.987,1.987,0,1,0,3.974,0V19.533a31.793,31.793,0,0,1,15.062-3.318,14.466,14.466,0,0,1-1.47-3.974Z",
  transform: "translate(0 10.275)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11498",
  "data-name": "Path 11498",
  d: "M40.858,16.2A35.37,35.37,0,0,0,26.711,12.23,14.823,14.823,0,0,1,25.26,16.2a31.574,31.574,0,0,1,13.393,3.338V25.3a1.987,1.987,0,1,0,3.974,0v-6.16A3.318,3.318,0,0,0,40.858,16.2Z",
  transform: "translate(22.959 10.265)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11499",
  "data-name": "Path 11499",
  d: "M15.161,19.231V17.9A6.1,6.1,0,0,1,16.234,5.759a6.259,6.259,0,0,1,4.372,1.768,16.214,16.214,0,0,1,3.378-2.146A10.194,10.194,0,0,0,6.1,11.879a10.134,10.134,0,0,0,9.339,9.935,14.743,14.743,0,0,1-.278-2.583Z",
  transform: "translate(4.047 0.046)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11500",
  "data-name": "Path 11500",
  d: "M28.411,1.83a10.272,10.272,0,0,0-7.331,3.078A15.638,15.638,0,0,1,24.855,6.9a6.239,6.239,0,0,1,9.8,5.007,6.14,6.14,0,0,1-3.557,5.5,14.187,14.187,0,0,1,.119,1.848,15.658,15.658,0,0,1-.2,2.384,10.134,10.134,0,0,0,7.61-9.737A10.174,10.174,0,0,0,28.411,1.83Z",
  transform: "translate(18.834 0)",
  fill: "#ac1ede"
}));

var SvgUsersprotfolio = function SvgUsersprotfolio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63.586,
    height: 63.924,
    viewBox: "0 0 63.586 63.924",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsersprotfolio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/usersprotfolio.524ce70c.svg";
export { ForwardRef as ReactComponent };